import { makeActionCreator } from '../../../utilities'
import { RulesConstants } from './rules.constants'

export const resetRulesState = makeActionCreator(RulesConstants.RESET_RULES_STATE)
export const setRulesErrors = makeActionCreator(RulesConstants.SET_RULES_ERRORS, 'errors')
export const runRule = makeActionCreator(RulesConstants.RUN_RULE)
export const runAllRules = makeActionCreator(RulesConstants.RUN_ALL_RULES)
export const setGroupedRulesErrors = makeActionCreator(RulesConstants.SET_GROUPED_RULES_ERRORS, 'groupedRulesErrors')
export const setDispatchedActions = makeActionCreator(RulesConstants.SET_DISPATCHED_ACTIONS, 'dispatchedActions')
export const setIsLoading = makeActionCreator(RulesConstants.SET_IS_LOADING, 'isLoading')
export const saveRuleErrors = makeActionCreator(RulesConstants.SAVE_RULE_ERRORS)
